import React, { useState, useEffect } from 'react';
import Menu from '../../elements/Menu/menu';
import CheckAuth from '../../elements/checkAuth';
import './reportByPeriod.css';
import '../../../../styles/table.admin.css';
import config from '../../../../config/environment';
import PageMode from '../../elements/PageMode/pageMode';
import UtilsService from '../../../MobileExchenger/elements/utilsService';
import axios from 'axios';

const MODES = ['TODAY', 'WEEK', 'MONTH', 'CUSTOM'];
const WAYS_MODES = [ 'ALL', 'BY_PROVIDER' ];

export default function ReportByPeriod() {
    const [state, setState] = useState({
        mode: 'TODAY',
        waysMode: 'ALL',
        reportByPeriod: null,
        showLoader: false,

        fromDate: null,
        toDate: null
    });

    useEffect(() => {
        const main = async () => {
            const now = new Date();
            const timeZone = now.getTimezoneOffset() * 60000;
            const currentDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const currentDayTimestamp = (+currentDay) - timeZone;

            const reportByPeriod = await getReportByPeriod(currentDayTimestamp);

            setState(state => { return { ...state, reportByPeriod }; })
        };
        main();
    }, []);

    const getReportByPeriod = async (fromTimestamp, toTimestamp = null) => {
        const body = { fromDate: fromTimestamp };
        if (toTimestamp) { body.toDate = toTimestamp; }

        try {
            const response = await axios.post(config.backendUrl + '/exchange-volume/report-by-period', body, { headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            }});
            return response.data;

        } catch (error) {
            console.log(error.message);
            console.log(error);
            alert(error.message);
        }
    };

    // Modes
    const modeHandler = async (event) => {
        const mode = event.target.value;
        const now = new Date();
        const timeZone = now.getTimezoneOffset() * 60000;
        const currentDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        setState(state => { return({ ...state, mode, showLoader: true }); });

        let fromTimestamp;

        switch (mode) {
            case 'TODAY':
                fromTimestamp = (+currentDay) - timeZone;
                break;

            case 'WEEK':
                const firstWeekDay = currentDay.getDate() - currentDay.getDay();
                fromTimestamp = (+new Date(currentDay.setDate(firstWeekDay)) - timeZone) + 864e5;
                break;

            case 'MONTH':
                const currentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                fromTimestamp = (+currentMonth) - timeZone;
                break;
        
            default:
                return setState(state => { return({ ...state, reportByPeriod: null, showLoader: false }); });
        }

        const reportByPeriod = await getReportByPeriod(fromTimestamp);

        setState(state => { return({ ...state, reportByPeriod, showLoader: false }); });
    };

    const waysModeHandler = async (event) => setState({ ...state, waysMode: event.target.value });

    // Render Custom Control
    const renderCustomControl = () => {
        if (state.mode !== 'CUSTOM') { return; }

        return(
            <div className="reportByPeriod__customMode_wrapper">
                <div className="reportByPeriod__customMode_dateMainWrapper">
                    <div className="reportByPeriod__customMode_dateWrapper">
                        <span className="reportByPeriod__customMode_dateLabel">From date</span>
                        <input type="date" onChange={ dateHandler('fromDate') }/>
                    </div>

                    <div className="reportByPeriod__customMode_dateWrapper">
                        <span className="reportByPeriod__customMode_dateLabel">To date</span>
                        <input type="date" onChange={ dateHandler('toDate') } />
                    </div>
                </div>
                <button onClick={ getReportButtonHandler }>Get report</button>
            </div>
        );
    };

    const dateHandler = (dateType) => (event) => {
        const newState = { ...state };
        newState[ dateType ] = event.target.value;
        setState(() => { return(newState); });
    };

    const getReportButtonHandler = async () => {
        if (!state.fromDate) {
            alert('Invalid from date');
            return;
        }

        setState(state => { return({ ...state, showLoader: true }); });

        const fromDateArray = state.fromDate.split('-');
        const fromTimestamp = +new Date(Date.UTC(parseInt(fromDateArray[0]), (parseInt(fromDateArray[1]) - 1), parseInt(fromDateArray[2])));

        let toTimestamp = null;
        if (state.toDate) {
            const toDateArray = state.toDate.split('-');
            toTimestamp = +new Date(Date.UTC(parseInt(toDateArray[0]), (parseInt(toDateArray[1]) - 1), parseInt(toDateArray[2])));
        }

        const reportByPeriod = await getReportByPeriod(fromTimestamp, toTimestamp);

        setState(state => { return({ ...state, reportByPeriod, showLoader: false }); });
    };

    // Render Tables
    const renderTables = () => {
        if (!state.reportByPeriod) { return; }

        if (state.showLoader) {
            return(
                <div className="reportByPeriod__loader">Loading...</div>
            );
        }

        return(
            <div className="reportByPeriod__tables_wrapper">
                { renderAmountsTable() }
                { renderCurrenciesVolumes() }
                { renderExchangeWaysVolumes() }
                { renderProvidersTable() }
                { renderCashbackTokensTable() }
            </div>
        );
    };

    const renderAmountsTable = () => {
        return(
            <div>
                <table className="table">
                    <thead><tr><th>Amounts</th></tr></thead>
                    <tbody>
                        <tr><td className="table__textAlign_left"><b>All:</b> { state.reportByPeriod.amounts.all }</td></tr>
                        <tr><td className="table__textAlign_left"><b>BUY:</b> { state.reportByPeriod.amounts.buy }</td></tr>
                        <tr><td className="table__textAlign_left"><b>SELL:</b> { state.reportByPeriod.amounts.sell }</td></tr>
                        <tr><td className="table__textAlign_left"><b>EXCHANGE:</b> { state.reportByPeriod.amounts.exchange }</td></tr>
                        <tr><td className="table__textAlign_left"><b>Average:</b> ~{ state.reportByPeriod.amounts.average }</td></tr>
                    </tbody>
                </table>
            </div>
        );
    };

    const renderCurrenciesVolumes = () => {
        return(
            <div className="reportByPeriod__currenciesVolumes">
                <div className="reportByPeriod__currenciesVolumes_tables">
                    <div>
                        <table className="table">
                            <thead><tr><th>Volumes: IN</th></tr></thead>
                            <tbody>
                                {
                                    Object.keys(state.reportByPeriod.volumes.in).map((currencyCode, index) => {
                                        return(
                                            <tr>
                                                <td className="table__textAlign_left">
                                                    <div><b>{ currencyCode }</b> { state.reportByPeriod.volumes.in[currencyCode].volume }</div>
                                                    <div><b>Average: { currencyCode }</b> { state.reportByPeriod.volumes.in[currencyCode].average }</div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <table className="table">
                            <thead><tr><th>Volumes: OUT</th></tr></thead>
                            <tbody>
                                {
                                    Object.keys(state.reportByPeriod.volumes.out).map((currencyCode, index) => {
                                        return(
                                            <tr>
                                                <td className="table__textAlign_left">
                                                    <div><b>{ currencyCode }</b> { state.reportByPeriod.volumes.out[currencyCode].volume }</div>
                                                    <div><b>Average: { currencyCode }</b> { state.reportByPeriod.volumes.out[currencyCode].average }</div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div><b>Fiat volume USD:</b> { state.reportByPeriod.volumes.sum.fiat }</div>
                <div><b>Crypto volume USD:</b> { state.reportByPeriod.volumes.sum.crypto }</div>
                <div><b>Total volume USD:</b> { state.reportByPeriod.volumes.sum.all }</div>
            </div>
        );
    };

    const getWaysArray = () => {
        let waysArray = [];
        for (let wayId in state.reportByPeriod.volumes.ways) {
            waysArray.push(state.reportByPeriod.volumes.ways[ wayId ]);
        }

        if (state.waysMode === 'ALL') {
            const arrayForAllTab = [];
            let alreadyAddedWay;

            for (let i = 0; i < waysArray.length; i++) {
                alreadyAddedWay = arrayForAllTab.find(wayInfo => wayInfo.inCurrencyCode === waysArray[i].inCurrencyCode &&
                    wayInfo.outCurrencyCode === waysArray[i].outCurrencyCode && wayInfo.inPaywayCode === waysArray[i].inPaywayCode &&
                    wayInfo.outPaywayCode === waysArray[i].outPaywayCode);
                
                if (alreadyAddedWay) {
                    alreadyAddedWay.inVolume = UtilsService.roundNumber((alreadyAddedWay.inVolume + waysArray[i].inVolume),
                        (!alreadyAddedWay.inCurrencyType || alreadyAddedWay.inCurrencyType === 'CRYPTO' ? 8 : 2));
                    alreadyAddedWay.outVolume = UtilsService.roundNumber((alreadyAddedWay.outVolume + waysArray[i].outVolume),
                        (!alreadyAddedWay.outCurrencyType || alreadyAddedWay.outCurrencyType === 'CRYPTO' ? 8 : 2));
                    alreadyAddedWay.percentage = UtilsService.roundNumber((alreadyAddedWay.percentage + waysArray[i].percentage), 2);
                    alreadyAddedWay.usdEquivalent = UtilsService.roundNumber((alreadyAddedWay.usdEquivalent + waysArray[i].usdEquivalent), 2);
                    alreadyAddedWay.count += waysArray[i].count;
                } else { arrayForAllTab.push({ ...waysArray[i] }); }
            }

            waysArray = arrayForAllTab;
        }

        waysArray = waysArray.sort((a, b) => b.count - a.count);
        waysArray = waysArray.sort((a, b) => b.percentage - a.percentage);
        waysArray = waysArray.sort((a, b) => b.usdEquivalent - a.usdEquivalent);

        return waysArray;
    };

    const renderExchangeWaysVolumes = () => {
        const waysArray = getWaysArray();

        return(
            <div className="reportByPeriod__currenciesVolumes">
                <PageMode radioName="waysModes" modesArray={ WAYS_MODES } checkedMode={ state.waysMode } onChangeHandler={ waysModeHandler } />
                <table className="table">
                    <thead>
                        <tr><th colspan="5">Volumes: ways</th></tr>
                        <tr>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Exchange way</td>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Payways</td>
                            {
                                state.waysMode === 'BY_PROVIDER' ?
                                    <td class="reportByPeriod__exchangeWaysVolumes_title">Provider</td>
                                    : null
                            }
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Volumes</td>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Statistics</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            waysArray.map((wayInfo, index) => {
                                return(
                                    <tr>
                                        <td>{ wayInfo.inCurrencyCode + ' >> ' + wayInfo.outCurrencyCode }</td>
                                        <td>{ wayInfo.inPaywayCode + ' >> ' + wayInfo.outPaywayCode }</td>
                                        {
                                            state.waysMode === 'BY_PROVIDER' ?
                                                <td>{ wayInfo.provider || '–' }</td>
                                                : null
                                        }
                                        <td className="table__textAlign_left">
                                            <div>
                                                <b>IN:</b> { wayInfo.inVolume }
                                                {
                                                    wayInfo.usdEquivalent !== 0 ?
                                                        <span className="reportByPeriod__usdEquivalent"> ~{ wayInfo.usdEquivalent }$</span>
                                                        : null
                                                }
                                            </div>
                                            <div><b>OUT:</b> { wayInfo.outVolume }</div>
                                        </td>
                                        <td className="table__textAlign_left">
                                            <div><b>Count:</b> { wayInfo.count }</div>
                                            {
                                                wayInfo.percentage !== 0 ?
                                                    <div><b>Percentage:</b> { wayInfo.percentage }</div>
                                                    : null
                                            }
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    };

    const getProvidersArray = () => {
        const providersObj = {};
        let wayInfo;

        for (let wayId in state.reportByPeriod.volumes.ways) {
            wayInfo = state.reportByPeriod.volumes.ways[ wayId ];

            if (providersObj[ wayInfo.provider ]) {
                providersObj[ wayInfo.provider ].all += wayInfo.count;
            } else {
                providersObj[ wayInfo.provider ] = {
                    all: wayInfo.count,
                    buy: 0,
                    sell: 0,
                    exchange: 0
                };
            }

            if (wayInfo.exchangeWayType) {
                providersObj[ wayInfo.provider ][ wayInfo.exchangeWayType.toLowerCase() ] += wayInfo.count;
            }
        }

        const providersArray = [];
        for (let providerName in providersObj) {
            providersArray.push({
                providerName,
                ...providersObj[ providerName ]
            });
        }

        return providersArray.sort((a, b) => b.all - a.all);
    };

    const renderProvidersTable = () => {
        const providersArray = getProvidersArray();

        return(
            <div className="reportByPeriod__providers_wrapper">
                <table className="table">
                    <thead>
                        <tr><th colspan="5">Providers</th></tr>
                        <tr>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Provider</td>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">All</td>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Buy</td>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Sell</td>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Exchange</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            providersArray.map((providerData, index) => {
                                return(
                                    <tr>
                                        <td>{ providerData.providerName }</td>
                                        <td>{ providerData.all || '–' }</td>
                                        <td>{ providerData.buy || '–' }</td>
                                        <td>{ providerData.sell || '–' }</td>
                                        <td>{ providerData.exchange || '–' }</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    };

    const renderCashbackTokensTable = () => {
        return(
            <div className="reportByPeriod__providers_wrapper">
                <table className="table">
                    <thead>
                        <tr><th colspan="3">Cashback tokens</th></tr>
                        <tr>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Index</td>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Cashback token</td>
                            <td class="reportByPeriod__exchangeWaysVolumes_title">Amount of orders</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            state.reportByPeriod.cashbackTokens.map((tokenData, index) => {
                                return(
                                    <tr>
                                        <td>{ index + 1 }</td>
                                        <td><a href={ '/skr/order-info?cashbackToken=' + tokenData.cashbackToken } target="_blank">{ tokenData.cashbackToken }</a></td>
                                        <td>{ tokenData.orderAmounts }</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            <div>
                <PageMode modesArray={ MODES } checkedMode={ state.mode } onChangeHandler={ modeHandler } />
                <div className='reportByPeriod__wrapper_scroll'>
                    <div className='reportByPeriod__content_scroll'>
                        { renderCustomControl() }
                        { renderTables() }
                    </div>
                </div>
            </div>
        </>
    );
};
